"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.number.constructor.js");

var _emitter = _interopRequireDefault(require("element-ui/lib/mixins/emitter"));

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('div', {
    staticClass: "el-checkbox-group",
    attrs: {
      "role": "group",
      "aria-label": "checkbox-group"
    }
  }, [_vm._t("default", null, {})], 2);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElCheckboxGroup',
  componentName: 'ElCheckboxGroup',
  mixins: [_emitter["default"]],
  inject: {
    elFormItem: {
      "default": ''
    }
  },
  props: {
    value: {},
    disabled: Boolean,
    min: Number,
    max: Number,
    size: String,
    fill: String,
    textColor: String,

    /** 扩展 */
    overflowTooltip: Boolean
    /** */

  },
  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    checkboxGroupSize: function checkboxGroupSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    }
  },
  watch: {
    value: function value(_value) {
      this.dispatch('ElFormItem', 'el.form.change', [_value]);
    }
  }
};
exports["default"] = _default;